import React, { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { DataView } from "primereact/dataview";

import WishListData from "./WishListProductData";


const WishListProduct = (props) =>{
    const { setIswishListVisible, isWishListVisible, products, cartItems, company, updateCartItems, setCartItems, buyerWishList, handleWishListChange} = props

    const [buyerWishListedProducts, setBuyerWishListProducts] = useState([])

    useEffect(() => {
        const buyerWishListedProducts = []
        let activeBuyerWishList = buyerWishList.filter(eachBuyerWishList => eachBuyerWishList.statusId === 1)
        activeBuyerWishList.map(eachBuyerWishList => {
            const relatedProduct = products.find(eachProduct => eachProduct.buyerRateContractId === eachBuyerWishList.buyerRateContractId)
            if(relatedProduct){
                buyerWishListedProducts.push(relatedProduct)
            }
        })

        setBuyerWishListProducts(buyerWishListedProducts)
    }, [buyerWishList, products])

    const itemTemplate = (product) => {
        return (
            <WishListData 
                product={product}
                cartItems={cartItems}
                company={company}
                updateCartItems={updateCartItems}
                setCartItems={setCartItems}
                handleWishListChange={handleWishListChange}
            />
        )
    }
    
    const displayProducts = buyerWishListedProducts.map(eachProduct => {
        const relatedCartItem = cartItems.find(prod => {
            return prod.buyerRateContractId == eachProduct.buyerRateContractId
        })
        return {
            eachProduct: eachProduct,
            relatedCartItem: relatedCartItem
        }
    })

    const renderHeader = () =>{
        return(
            <div className="flex flex-row">
                <h3>Wishlist</h3>
            </div>
        )
    } 
    
    return(
        <Dialog className="whish-list-dialog" header={renderHeader} style={{ width: '70vw', height: '85vh'}}  visible={isWishListVisible} onHide={() =>setIswishListVisible(false)}>
            <div>
                {
                    displayProducts.length ?
                    <div className="catalogue-request buyer-portal-card-container flex flex-wrap ml-3">
                        <DataView 
                            value={displayProducts} 
                            itemTemplate={itemTemplate}
                            paginator 
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            rows={20} 
                        />
                    </div>
                    :
                    null
                }
            </div>
        </Dialog>
    )
}

export default WishListProduct;